import { z } from 'zod';
import { LocaleSchema } from '../settings';

export const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;

export const TenantPublicSchema = z.object({
  kind: z.enum(['tenant', 'platform']),
  productName: z.string(),
  slug: z.string(),
  name: z.string(),
  shortName: z.string(),
  legalName: z.string().nullable(),
  /** Public contact (letterhead, verification page). */
  phone: z.string().nullable(),
  primaryColor: z.string().regex(HEX_COLOR),
  logoUrl: z.string().nullable(),
  defaultLocale: LocaleSchema,
  locales: z.array(LocaleSchema),
  /** Label of the current academic year, e.g. 2026-2027. */
  currentYear: z.string().nullable(),
  features: z.object({ sso: z.boolean() }),
});
export type TenantPublic = z.infer<typeof TenantPublicSchema>;

export const TenantSummarySchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  shortName: z.string(),
  status: z.enum(['active', 'suspended']),
  primaryColor: z.string(),
  createdAt: z.string(),
  users: z.number().int(),
  students: z.number().int(),
});
export type TenantSummary = z.infer<typeof TenantSummarySchema>;

/** Platform console « fiche établissement »: accounts per role, administrators and their invitation state. */
export const TenantDetailSchema = TenantSummarySchema.extend({
  currentYear: z.string().nullable(),
  roles: z.array(z.object({ role: z.string(), count: z.number().int() })),
  admins: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      email: z.string().nullable(),
      /** `invited` = the invitation link was never used (no password yet). */
      state: z.enum(['invited', 'active', 'disabled']),
      lastLoginAt: z.string().nullable(),
    }),
  ),
});
export type TenantDetail = z.infer<typeof TenantDetailSchema>;
